import React, { PropsWithChildren, createContext, useEffect, useState } from "react";

import { ThemeProvider } from "@mui/material";

import { appTheme } from "@/contexts";

type ColorModeContextType = {
  mode: string;
  setMode: () => void;
};

export const ColorModeContext = createContext<ColorModeContextType>({} as ColorModeContextType);

/**
 * This context provider is used to manage the color mode of the application
 * first we check if the user has a color mode saved in the local storage
 * if not we check the system preference
 */
export const ColorModeContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const colorModeFromLocalStorage = localStorage.getItem("colorMode");
  const isSystemPreferenceDark = window?.matchMedia("(prefers-color-scheme: dark)").matches;

  const systemPreference = isSystemPreferenceDark ? "dark" : "light";
  const [mode, setMode] = useState(colorModeFromLocalStorage || systemPreference);

  useEffect(() => {
    window.localStorage.setItem("colorMode", mode);
  }, [mode]);

  const setColorMode = () => {
    if (mode === "light") {
      setMode("dark");
    } else {
      setMode("light");
    }
  };

  return (
    <ColorModeContext.Provider
      value={{
        setMode: setColorMode,
        mode,
      }}
    >
      <ThemeProvider
        // you can change the theme colors here. example: mode === "light" ? RefineThemes.Blue : RefineThemes.BlueDark
        theme={mode === "light" ? appTheme : appTheme}
      >
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};
